import { render, staticRenderFns } from "./oneSection.vue?vue&type=template&id=c4180f08&scoped=true&"
import script from "./oneSection.vue?vue&type=script&lang=js&"
export * from "./oneSection.vue?vue&type=script&lang=js&"
import style0 from "./oneSection.vue?vue&type=style&index=0&id=c4180f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4180f08",
  null
  
)

export default component.exports